import { render, staticRenderFns } from "./viewQuotation.vue?vue&type=template&id=b882cd38"
import script from "./viewQuotation.vue?vue&type=script&lang=js"
export * from "./viewQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports